import React, { useRef } from "react"
import Icon from "@kit/design/icon"
import { useToggle } from "hooks/use-toggle"
import Stack from "@kit/design/stack"

export function Expander({ label, children, open = false, onToggle }) {
  const [active, toggle] = useToggle(open)
  const activeRef = useRef(active)
  activeRef.current = active

  const handleToggle = () => {
    toggle()
    if (onToggle) onToggle(!activeRef.current)
  }

  return (
    <div className={`border-t relative ${active ? "mb-4" : ""}`}>
      <button
        className="py-4 leading-none text-gray-900 flex items-center justify-between w-full font-semibold focus:outline-none focus:text-gray-700 hover:text-gray-700 duration-200 transition-colors"
        style={{ fontSize: "1.05em" }}
        onClick={handleToggle}
      >
        {label}
        <Icon
          name="down"
          className={`text-gray-500 absolute right-0 transform transition-transform ease-linear duration-100 ${
            active ? "-rotate-180" : ""
          }`}
        />
      </button>
      <Stack spacing={4}>{active && children}</Stack>
    </div>
  )
}
